<template>
    <div id="app" class="antialiased text-gray-900">
        <router-view/>
        <portal-target name="modals"></portal-target>
        <loading-progress></loading-progress>
    </div>
</template>

<script>
    import LoadingProgress from '@investor/components/LoadingProgress'

    export default {
        components: {
            LoadingProgress,
        },
        created() {
        }
    }
</script>
